var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import commonTypes from '../../actions/types/common.types';

// TODO (kup) - this is firing multiple times because on every reducer
// exist return commonReducer(state, action) and its fire this custom reducer
// but in view fired only once its correct
export default ((state = XHR_STATE, action) => {
    switch (action.type) {

        case commonTypes.COMMON_HANDLE_ERROR:
            return reduceHandleError(state, action);

        case commonTypes.COMMON_CLEAR_ERROR:
            return reduceClearError(state, action);

        default:
            return state;
    }
});

const reduceHandleError = (state, action) => {
    const { error } = action.payload;
    return _extends({}, state, {
        error
    });
};

const reduceClearError = (state, action) => {
    return _extends({}, state, {
        error: null
    });
};

export const XHR_STATE = {
    error: null
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/reducers/service/common.reducer.js